(function () {
  var WKEY = 'sw_wishlist';
  var RKEY = 'sw_recently';
  var MAXR = 12;

  function load(k) { try { return JSON.parse(localStorage.getItem(k)) || []; } catch (e) { return []; } }
  function save(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function esc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function heartSvg() { return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21S3 14.5 3 8.5A5 5 0 0 1 12 5a5 5 0 0 1 9 3.5C21 14.5 12 21 12 21z"/></svg>'; }

  function getWishlist() { return load(WKEY); }
  function inWishlist(id) { return getWishlist().some(function (i) { return String(i.id) === String(id); }); }

  function toggleWishlist(item) {
    var list = getWishlist();
    var idx = -1;
    for (var i = 0; i < list.length; i++) { if (String(list[i].id) === String(item.id)) { idx = i; break; } }
    if (idx > -1) list.splice(idx, 1); else list.unshift(item);
    save(WKEY, list);
    updateHearts(); updateCount(); renderWishlist();
    return idx === -1;
  }

  function updateCount() {
    var n = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n; el.hidden = n === 0;
    });
  }

  function updateHearts() {
    var list = getWishlist();
    document.querySelectorAll('.sw-wish-btn').forEach(function (btn) {
      var active = list.some(function (i) { return String(i.id) === String(btn.dataset.wishId); });
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function itemFromBtn(btn) {
    return {
      id: btn.dataset.wishId, handle: btn.dataset.wishHandle, title: btn.dataset.wishTitle,
      url: btn.dataset.wishUrl, image: btn.dataset.wishImage, price: btn.dataset.wishPrice
    };
  }

  function bindHearts(root) {
    (root || document).querySelectorAll('.sw-wish-btn').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var added = toggleWishlist(itemFromBtn(btn));
        btn.classList.toggle('sw-wish-btn--pop', added);
        if (added) setTimeout(function () { btn.classList.remove('sw-wish-btn--pop'); }, 350);
      });
    });
  }

  function cardHTML(p) {
    return '' +
      '<div class="sw-wl-card">' +
        '<button class="sw-wish-btn is-active" data-wish-id="' + esc(p.id) + '" data-wish-handle="' + esc(p.handle) + '" data-wish-title="' + esc(p.title) + '" data-wish-url="' + esc(p.url) + '" data-wish-image="' + esc(p.image || '') + '" data-wish-price="' + esc(p.price || '') + '" aria-label="Toggle wishlist" aria-pressed="true">' + heartSvg() + '</button>' +
        '<a class="sw-wl-card__img" href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
        '<div class="sw-wl-card__body">' +
          '<a class="sw-wl-card__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          (p.price ? '<div class="sw-wl-card__price">' + esc(p.price) + '</div>' : '') +
          '<a class="sw-wl-card__btn" href="' + esc(p.url) + '">View Product</a>' +
        '</div>' +
      '</div>';
  }

  function renderWishlist() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var list = getWishlist();
    var empty = document.querySelector('[data-wishlist-empty]');
    var countEl = document.querySelector('[data-wishlist-page-count]');
    if (countEl) countEl.textContent = list.length;
    if (!list.length) { grid.innerHTML = ''; if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    grid.innerHTML = list.map(cardHTML).join('');
    bindHearts(grid);
  }

  function trackRecently() {
    var d = document.querySelector('[data-sw-product]');
    if (!d) return;
    var item = { id: d.dataset.id, handle: d.dataset.handle, title: d.dataset.title, url: d.dataset.url, image: d.dataset.image, price: d.dataset.price };
    if (!item.id) return;
    var list = load(RKEY).filter(function (i) { return String(i.id) !== String(item.id); });
    list.unshift(item);
    if (list.length > MAXR) list = list.slice(0, MAXR);
    save(RKEY, list);
  }

  function renderRecently() {
    var grid = document.querySelector('[data-recently-grid]');
    if (!grid) return;
    var cur = grid.dataset.currentId;
    var list = load(RKEY).filter(function (i) { return String(i.id) !== String(cur || ''); });
    var empty = document.querySelector('[data-recently-empty]');
    if (!list.length) { grid.innerHTML = ''; if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    grid.innerHTML = list.map(cardHTML).join('');
    bindHearts(grid);
    updateHearts();
  }

  function init() {
    bindHearts(); updateHearts(); updateCount();
    trackRecently();
    renderWishlist(); renderRecently();
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function () { bindHearts(); updateHearts(); renderWishlist(); renderRecently(); });
})();
